/* PreTech Park — shared shell behaviour for the redesign demo pages. Exposes window.PTP helpers. */
(function(){
  'use strict';
  document.documentElement.classList.add('js');
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function smooth(t){return t*t*(3-2*t)}
  function seg(p,a,b){return clamp((p-a)/(b-a),0,1)}

  /* live clock */
  function pad(n){return (n<10?'0':'')+n}
  function tick(){var d=new Date(),s=d.getFullYear()+'.'+pad(d.getMonth()+1)+'.'+pad(d.getDate())+' - '+pad(d.getHours())+':'+pad(d.getMinutes())+':'+pad(d.getSeconds());$$('[data-clock]').forEach(function(e){e.textContent=s})}
  tick();setInterval(tick,1000);

  /* barcodes */
  $$('svg[data-barcode]').forEach(function(svg){var x=0,seed=+(svg.getAttribute('data-barcode'))||26,o='';function r(){seed=(seed*9301+49297)%233280;return seed/233280}
    while(x<150){var w=1+Math.floor(r()*3);if(r()>.32)o+='<rect x="'+x+'" y="0" width="'+w+'" height="28"/>';x+=w+1}svg.innerHTML=o});

  /* chamfered frames */
  var NS='http://www.w3.org/2000/svg';
  function drawFrame(el){
    var s=null;for(var i=0;i<el.children.length;i++){var c=el.children[i];if(c.classList&&c.classList.contains('fr')){s=c;break}}
    if(!s){s=document.createElementNS(NS,'svg');s.setAttribute('class','fr');s.setAttribute('aria-hidden','true');s.appendChild(document.createElementNS(NS,'polygon'));el.insertBefore(s,el.firstChild);el.classList.add('has-fr')}
    var w=el.offsetWidth,h=el.offsetHeight;if(!w||!h)return;var k=Math.min(+(el.getAttribute('data-frame'))||18,w/3,h/3);
    s.setAttribute('viewBox','0 0 '+w+' '+h);s.setAttribute('width',w);s.setAttribute('height',h);
    s.firstChild.setAttribute('points','.5,.5 '+(w-k)+',.5 '+(w-.5)+','+k+' '+(w-.5)+','+(h-.5)+' '+k+','+(h-.5)+' .5,'+(h-k));
  }
  var ro=('ResizeObserver' in window)?new ResizeObserver(function(es){es.forEach(function(en){drawFrame(en.target)})}):null;
  function frames(root){$$('[data-frame]',root).forEach(function(el){drawFrame(el);if(ro)ro.observe(el)})}
  frames();
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){$$('[data-frame]').forEach(drawFrame)});

  /* text scramble */
  var CH='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*/<>';
  function scramble(el,text,dur){
    if(!el)return;text=(text==null)?(el.getAttribute('data-text')||el.textContent):text;
    if(reduce){el.textContent=text;return}
    clearInterval(el._sc);var t0=Date.now();dur=dur||900;
    el._sc=setInterval(function(){var k=Math.min(1,(Date.now()-t0)/dur),n=Math.floor(k*text.length),o=text.slice(0,n);
      for(var i=n;i<text.length;i++){var c=text[i];o+=(c===' ')?c:CH[(Math.random()*CH.length)|0]}
      el.textContent=o;if(k>=1){clearInterval(el._sc);el.textContent=text}},45);
  }
  function swapText(el,txt){if(!el||el.textContent===txt)return;el.style.opacity=0;setTimeout(function(){el.textContent=txt;el.style.opacity=1},150)}
  $$('[data-scramble-in]').forEach(function(el,i){setTimeout(function(){scramble(el,null,+(el.getAttribute('data-scramble-in'))||1100)},180+i*160)});

  /* reveals (+ optional data-onreveal hook names) */
  var hooks={};
  var io=new IntersectionObserver(function(es){es.forEach(function(en){if(!en.isIntersecting)return;var t=en.target;t.classList.add('in');io.unobserve(t);
    var h=t.getAttribute('data-onreveal');if(h&&hooks[h])hooks[h](t)})},{threshold:.16});
  function observe(root){$$('.rv',root).forEach(function(el){io.observe(el)})}
  observe();

  /* footer index decode */
  $$('.dir__row').forEach(function(row){var t=row.querySelector('.dir__t');function go(){scramble(t,null,380)}row.addEventListener('mouseenter',go);row.addEventListener('focus',go)});

  /* copy email */
  var cm=$('#copyMail');if(cm)cm.addEventListener('click',function(){
    var b=this,el=$('#mail'),txt=el.textContent;
    function sel(){var r=document.createRange();r.selectNodeContents(el);var s=getSelection();s.removeAllRanges();s.addRange(r);b.textContent='Selected'}
    try{navigator.clipboard.writeText(txt).then(function(){b.textContent='Copied'},sel)}catch(e){sel()}
    setTimeout(function(){b.textContent='Copy'},1800);
  });

  /* section progress helper for pinned stages */
  function prog(el){var H=innerHeight,r=el.getBoundingClientRect();return {r:r,p:clamp(-r.top/Math.max(1,r.height-H),0,1),approach:clamp(1-r.top/H,0,1)}}

  window.PTP={$:$,$$:$$,clamp:clamp,lerp:lerp,smooth:smooth,seg:seg,reduce:reduce,scramble:scramble,swapText:swapText,hooks:hooks,observe:observe,frames:frames,prog:prog};
})();

/* ---- Menu button (phones) + footer social tuner — self-contained so pages with their own shell copy can include it too ---- */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches,CH='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*/<>';
  function q(s,r){return (r||document).querySelector(s)}function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function scr(el,text,dur){if(!el)return;text=text==null?(el.getAttribute('data-text')||el.textContent):text;if(reduce){el.textContent=text;return}
    clearInterval(el._tsc);var t0=Date.now();el._tsc=setInterval(function(){var k=Math.min(1,(Date.now()-t0)/dur),n=Math.floor(k*text.length),o=text.slice(0,n);
      for(var i=n;i<text.length;i++){var c=text[i];o+=c===' '?c:CH[(Math.random()*CH.length)|0]}el.textContent=o;if(k>=1){clearInterval(el._tsc);el.textContent=text}},45)}
  var hud=q('.hud'),bur=q('.burger');
  function shut(){hud.classList.remove('open');bur.setAttribute('aria-expanded','false');bur.textContent='Menu'}
  if(hud&&bur){bur.addEventListener('click',function(){var o=hud.classList.toggle('open');bur.setAttribute('aria-expanded',o);bur.textContent=o?'Close':'Menu'});
    qa('nav a',hud).forEach(function(a){a.addEventListener('click',shut)});
    addEventListener('keydown',function(e){if(e.key==='Escape'&&hud.classList.contains('open')){shut();bur.focus()}})}
  var tune=q('#tune');if(!tune)return;
  var sts=qa('.tune__st',tune),now=q('#tuneNow'),eq=qa('.tune__eq i'),ti=-1,held=false;
  function tuneTo(i,dec){var s=sts[i];if(!s)return;var same=i===ti;ti=i;sts.forEach(function(x,k){x.classList.toggle('on',k===i)});
    tune.style.setProperty('--nx',((s.offsetLeft+s.offsetWidth/2)/tune.offsetWidth*100).toFixed(2)+'%');
    if(!same&&now)scr(now,s.querySelector('b').getAttribute('data-text'),360);if(dec)scr(s.querySelector('b'),null,420);
    var n=eq.length,a=Math.floor(i*n/sts.length),b=Math.floor((i+1)*n/sts.length);eq.forEach(function(e,k){e.classList.toggle('hot',k>=a&&k<b)})}
  sts.forEach(function(s,i){s.addEventListener('mouseenter',function(){held=true;tuneTo(i,true)});s.addEventListener('focus',function(){held=true;tuneTo(i,true)});s.addEventListener('blur',function(){held=false})});
  tune.addEventListener('mouseleave',function(){held=false});
  tuneTo(0);if(!reduce)setInterval(function(){if(!held&&!document.hidden)tuneTo((ti+1)%sts.length)},2600);
  addEventListener('resize',function(){tuneTo(ti)});
})();
